module.exports = __webpack_public_path__ + "static/media/image7.366e94a9.jpg";